
var dispatcher = require("../dispatcher");
module.exports = {
    saveLogin: function (loginInfo) {
        dispatcher.dispatch({
            loginInfo: loginInfo,
            type: "login:saveLogin"
        })
    },
    saveSignIn: function (SignInInfo) {
        dispatcher.dispatch({
            SignInInfo: SignInInfo,
            type: "login:saveSignIn"
        })
    },
    updateLogin: function (loginDetail) {
        dispatcher.dispatch({
            loginDetail: loginDetail,
            type: "login:updateLogin"
        })
    },
    deleteLogin: function (LoginId) {
        dispatcher.dispatch({
            LoginId: LoginId,
            type: "login:deleteLogin"
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/LoginAction.js